var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin div100"> <div id="module_margin" class="div100"> <iframe id="officeWord_officeWord" style="height:100%;width:100%" src="https://www.youtube.com/embed/CezgTNwk1-s?autoplay=1&start=5" allow="autoplay" frameborder="0"></iframe> </div> </div> </div>';
}
return __p;
};
